<script setup lang="ts">
interface Props {
  size?: number
  circle?: boolean
  text?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 12,
  circle: false,
})
</script>

<template>
  <div class="loading-container">
    <div v-if="circle" class="loading-container">
      <div class="circle-loader" :style="{ width: `${props.size * 3}px`, height: `${props.size * 3}px` }" />
      <span v-if="text">{{ text }}</span>
    </div>
    <div v-else class="loading-container">
      <div class="loader">
        <div v-for="index of 3" :key="index" :class="`dot dot${index}`" :style="{ width: `${props.size}px`, height: `${props.size}px` }" />
      </div>
      <span v-if="text">{{ text }}</span>
    </div>
  </div>
</template>

  <style scoped>
  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column
  }

  .loader {
    display: flex;
    gap: 0.5rem;
  }

  .dot {
    background-color: rgb(var(--v-theme-primary));
    border-radius: 50%;
    animation: bounce 0.6s infinite alternate;
  }

  .dot1 {
    animation-delay: 0s;
  }
  .dot2 {
    animation-delay: 0.2s;
  }
  .dot3 {
    animation-delay: 0.4s;
  }

  @keyframes bounce {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-1rem);
    }
  }

.circle-loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid rgb(var(--v-theme-primary));
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
